import React from 'react'
import styled from 'styled-components'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'

import Button from '../../display/Button'
import ArrowRightSlimIcon from '../../icons/ArrowRightSlim'

import { TextField } from '..'

type AppearanceProps = {
  appearance?: 'flush' | 'raised'
  solidButton?: boolean
}

const TextFieldWrapper = styled.div<AppearanceProps>`
  position: relative;
  display: flex;
  width: 100%;
  flex: 1;

  ${TextField} {
    border-radius: 6px;
    border-color: white;
  }

  input[type='email'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;

    ${({ appearance }) =>
      appearance === 'flush' &&
      `
      margin-right: 16px;
      `}
  }

  ${({ appearance, solidButton, theme }) =>
    appearance === 'raised' &&
    `
    margin: 16px 0;
    border-radius: 8px;
    background-color: ${theme?.['-ds-neutral-100']?.value};
    box-shadow: 0 1px 10px 0 rgb(144 116 102 / 20%);

    :focus-within {
      box-shadow: 0 1px 10px 0 rgb(144 116 102 / 40%);
    }

    ${
      solidButton &&
      `
      padding: 16px 16px 16px 0;
    `
    }
  `}
`

const FormContainer = styled.div`
  display: flex;
  justify-content: center;
`

const SubmitButton = styled(Button)`
  flex-shrink: 0;
  margin: 0;
  padding: 14px 16px;

  svg {
    width: 28px;
    height: 28px;
    margin: 0;
  }
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 12px 0;
  margin-bottom: 40px;
  width: 100%;

  label {
    margin: 0 0 12px 0;
    line-height: 26px;
    font-weight: inherit;
  }
`

const DEFAULT_ACTION =
  '//riparide.us2.list-manage.com/subscribe/post?u=7b235a0b84e1f694020e638b5&id=cd3dc805a2'
const DEFAULT_TOKEN = 'b_7b235a0b84e1f694020e638b5_cd3dc805a2'

type EmailSignupProps = AppearanceProps & {
  action?: string
  token?: string
  placeholder?: string
  labelInner?: React.ReactNode
  buttonLabel?: React.ReactNode
}

const EmailSignup = ({
  appearance = 'flush',
  action = DEFAULT_ACTION,
  token = DEFAULT_TOKEN,
  placeholder = 'Your email, of course!',
  labelInner,
  solidButton,
  buttonLabel = 'Subscribe',
}: EmailSignupProps) => {
  const { md: largerThanMd } = useMediaQueryContext()

  return (
    <FormContainer>
      <Form
        action={action}
        method="post"
        target="_blank"
        name="mc-embedded-subscribe-form"
      >
        {labelInner && <label htmlFor="EMAIL">{labelInner}</label>}

        <TextFieldWrapper appearance={appearance} solidButton={solidButton}>
          <TextField
            placeholder={placeholder}
            type="email"
            name="EMAIL"
            id="EMAIL"
            tabIndex={-1}
            required
          />
          <SubmitButton
            type="submit"
            name="subscribe"
            uppercase={false}
            aria-label="Subscribe to Riparide"
          >
            {largerThanMd ? buttonLabel : <ArrowRightSlimIcon />}
          </SubmitButton>
        </TextFieldWrapper>
        <div
          aria-hidden="true"
          style={{ position: 'absolute', left: '-5000px' }}
        >
          <input type="text" name={token} defaultValue="" tabIndex={-1} />
        </div>
      </Form>
    </FormContainer>
  )
}

export default EmailSignup
